import React, {Component} from 'react';
import '../InfluencerMap.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import CustomerGroupsAdd  from './CustomerGroupsAdd/CustomerGroupsAdd';
import CustomerGroupsList from './CustomerGroupsList/CustomerGroupsList';
import DeleteModal from '../../../shared/Common/deleteModal';
import DisableNextModal from '../../../shared/Common/disableNextModal';

class CustomerGroups extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            createdData: false,
            editedData: false,
            deleteModalState: false,
            deletedItemId: null,
            adddedData: false,
        };
    }

    componentWillMount(){
        let body = {
            projectId: this.props.projectId,
            type: 'influencerMap'
        }
        this.props.getInfluencerMapGroups(body);
    }

    componentWillReceiveProps(nextProps){
        if(this.props.addInfluencerMapGroupsData !== nextProps.addInfluencerMapGroupsData){
            let body = {
                projectId: this.props.projectId,
                type: 'influencerMap'
            }
            this.props.getInfluencerMapGroups(body);

        }
        if(nextProps.getInfluencerMapGroupsData !== this.props.getInfluencerMapGroupsData ){
            if( _.isEmpty(nextProps.getInfluencerMapGroupsData.Items) && !this.state.createdData){
                this.setState({createdData : true, editedData: false })
            }

            if( !_.isEmpty(nextProps.getInfluencerMapGroupsData.Items) && !this.state.editedData){
                this.setState({editedData : true, createdData : false})
                //this.defaultParams = _.extend(nextProps.getInfluencerMapGroupsData.Items[0].groups)
                this.defaultParams = nextProps.getInfluencerMapGroupsData.Items[0].groups
            }
        }
    }

    addCustomerGroups = (data) => {
        if(this.state.createdData) {
            let body = {
                type : 'influencerMap',
                projectId : this.props.projectId,
                groups: [
                    {
                        groupId: data.groupId,
                        groupName: data.groupName,
                    },
                ]
            }
            this.props.addInfluencerMapGroups(body);
        }

        if(this.state.editedData) {
            this.defaultParams.push(data);
            let body = {
                type : 'influencerMap',
                id : this.props.getInfluencerMapGroupsData.Items[0].id,
                groups : this.defaultParams
            }
            this.props.editInfluencerMapGroups(body);
        }
    }

    deleteItem = () => {
        let updatedData = [];
        const updatedGroupsMap = [];

        for (let item of this.defaultParams){
            item.groupId !== this.state.deletedItemId && updatedData.push(item) ;
        }

        for(const group of this.props.getInfluencerMapGroupsData.Items[0].groupsMap){
            if(group.groupId !== this.state.deletedItemId) updatedGroupsMap.push(group);
        }

        this.defaultParams = updatedData;
        let body = {
            type : 'influencerMap',
            id : this.props.getInfluencerMapGroupsData.Items[0].id,
            groups : updatedData,
            groupsMap: updatedGroupsMap
        }

        this.props.editInfluencerMapGroups(body);
        this.deleteModalClose()
    }

    deleteModalOpen = (id) => {
        this.setState({ deleteModalState : true, deletedItemId : id })
    }

    deleteModalClose = () => {
        this.setState({ deleteModalState : false, deletedItemId : null })
    }

    firstStepNext = () => {
        if(this.props.getInfluencerMapGroupsData.Items.length > 0 && this.props.getInfluencerMapGroupsData.Items[0].groups.length > 0 ){

            this.props.groupStateNext();
        }else{
            this.props.disableNextModal();
        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    render() {

        return(
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-six arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 5</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                  <div className="row">
                    <div className="col-lg-7">
                      <h5>Influencer Map</h5>
                    </div>
                  </div>
                    { !this.props.getInfluencerMapGroupsFetching &&
                        <div className='row'>
                            <div className='col-lg-7'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h5>Customer Groups</h5>
                                        <span>Enter all of the Customer Groups – Influencers, Users, Decision-Makers, etc. – that could be considered stakeholders in your market</span>
                                    </div>
                                    <div className='card-body'>
                                        <CustomerGroupsAdd
                                            addCustomerGroups={this.addCustomerGroups}
                                        />

                                        {  !_.isEmpty(this.props.getInfluencerMapGroupsData.Items) &&
                                            <CustomerGroupsList
                                                getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                deleteItem={this.deleteItem}
                                                deleteModalOpen={this.deleteModalOpen}
                                                groupStepState={this.props.groupStepState}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success'
                                        onClick={this.firstStepNext}>Next</div>
                                        <Link to='/toolkit' className='btn empty-btn default'> Back </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    { this.props.getInfluencerMapGroupsFetching &&
                        <div className='card'>
                            <div className="card-body">
                                {this.elementInfiniteLoad()}
                            </div>
                        </div>
                    }

                </div>
                {this.state.deleteModalState &&
                    <DeleteModal
                        deleteItem={this.deleteItem}
                        deleteModalState={this.state.deleteModalState}
                        deleteModalClose={this.deleteModalClose}
                    />
                }

                { this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText='You must create at least 1 Customer Group before continuing to Step 2'
                        disableModalTitle='Customer Groups'
                    />
                }
            </div>
        )
    }
}

export default (CustomerGroups);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerGroups/CustomerGroups.jsx